import ButtonUi from "@UI/ButtonUi";
import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";

import "./style.scss";

const Cookies = inject("mainStore")(
    observer(({ mainStore }) => {
        const modal = mainStore.getMainStore("modal");
        const [cookieConsent, setCookieConsent] = useState(false);
        const { type } = modal;

        useEffect(() => {
            const cookieValue = getCookie("_rispromo_cookie");
            if (!cookieValue) setCookieConsent(true);
        }, []);

        const setCookie = (name, value, days) => {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            const expires = `expires=${date.toUTCString()}`;
            document.cookie = `${name}=${value}; ${expires}; path=/`;
        };

        const getCookie = (name) => {
            const cookiesArray = document.cookie.split("; ");
            for (let i = 0; i < cookiesArray.length; i++) {
                const [cookieName, cookieValue] = cookiesArray[i].split("=");
                if (cookieName === name) {
                    return cookieValue;
                }
            }
            return null;
        };

        const handleClickCookies = () => {
            setCookie("_rispromo_cookie", "true", 365);
            setCookieConsent(false);
        };

        return !["ava-wheel", "fortune"].includes(type) && cookieConsent ? ( // не показывать куки пока крутятся колеса
            <div className="cookies">
                <div className="cookies__main">
                    <div className="cookies__container">
                        <span className="cookies__title">
                            Мы используем{" "}
                            <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" className="cursor" rel="noreferrer">
                                cookies
                            </a>
                        </span>
                    </div>

                    <ButtonUi onClick={handleClickCookies} label="Ок" className={`cookies__btn`} />
                </div>
            </div>
        ) : null;
    }),
);

export default Cookies;
